






















import { Component, Prop, Vue } from "vue-property-decorator";
import { DebugHelper } from "@/helper/debugHelper";

import { CloudAccount } from "@/cloudAccount/cloudAccount";

@Component({
  components: {
  }
})

export default class selectOpenStorageModal extends Vue {

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    public get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private localButtonClick(){
        this.$emit("importDocument", "importLocalDocument");
        this.$emit("select");
        // 選択したら消す
        this.$emit('close');
    }

    private cloudButtonClick(){
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$store.dispatch("setCloudMode", "open");

        if(this.cloudAccount.isSignIn){
            this.$router.push("/Cloud");
        }
        else{
            this.$store.dispatch("setSignInToGo", "Cloud");
            this.$router.push("/SignIn");
        }
        // 選択したら消す
        this.$emit('close');
    }
    
    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
